// Lily & June: add variants to the cart from custom blocks (add-on tick box, "Buy more" list, after-add offer)
// the same way hybrid-cart-actions.js does, so the Horizon drawer re-renders and auto-opens.
//   await window.ljCartAdd([{ id: 123, quantity: 1 }])  -> true on success
import { CartLinesUpdateEvent } from '@shopify/events';

window.ljCartAdd = async (items, origin = document.body) => {
  const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((c) => c.dataset.sectionId).filter(Boolean))];
  const deferred = CartLinesUpdateEvent.createPromise();
  origin.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: items.map((i) => ({ merchandiseId: `gid://shopify/ProductVariant/${i.id}`, quantity: i.quantity })), promise: deferred.promise }));
  try {
    const res = await fetch(Theme.routes.cart_add_url, {
      method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items, sections: sectionIds.join(','), sections_url: window.location.pathname }),
    });
    const result = await res.json();
    if (!res.ok || result.status) throw new Error(result.description || 'Add failed');
    const cart = await (await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })).json();
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: false, items: cart.items, sections: result.sections, source: 'lj-cart-add' } });
    return true;
  } catch (e) {
    deferred.reject(e);
    return false;
  }
};
